import { FC } from "react";
import { MantineProvider } from "@mantine/core";
import { NotificationsProvider } from "@mantine/notifications";

export const MantineApp: FC = ({ children }) => {
  return (
    <MantineProvider withNormalizeCSS>
      <NotificationsProvider>{children}</NotificationsProvider>
    </MantineProvider>
  );
};
